import { type ReactNode } from 'react';
import { GlowOrb } from '@/components/effects/glow-orb';
import { Background3333 } from '@/components/effects/background-3333';
import { NoiseOverlay } from '@/components/effects/noise-overlay';
import { Vignette } from '@/components/effects/vignette';
import { FloatingBubbles } from '@/components/effects/floating-bubbles';
import { HomeContent } from './home-content';

export function HomePage(): ReactNode {
  return (
    <div className="relative flex min-h-dvh items-center justify-center overflow-hidden bg-void">
      <Background3333 />
      <GlowOrb />
      <Vignette />
      <NoiseOverlay />
      <FloatingBubbles />
      <HomeContent />
    </div>
  );
}
